import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function HomeRedirect() {
  const { user, isSuperAdmin, activePortal } = useAuth();
  
  if (isSuperAdmin || user?.type === 'SuperAdmin' || activePortal === 'superadmin') {
    return <Navigate to="/superadmin/control-tower" replace />;
  }

  const isClientUser = user?.type === 'Client' || String(user?.portal_access || '').toLowerCase().includes('client');
  if (!isClientUser && (activePortal === 'vendor' || user?.type === 'Vendor' || user?.portal_access === 'Vendor Portal')) {
    return <Navigate to="/vendor/dashboard" replace />;
  }
  
  return <Navigate to="/dashboard" replace />;
}
